import React, { useState } from "react"

interface PublicMenuImageThumbnailProps {
  image?: string | null
  alt: string
  imageClassName: string
  onPreview: (image: string, alt: string) => void
}

export const PublicMenuImageThumbnail: React.FC<PublicMenuImageThumbnailProps> = ({
  image,
  alt,
  imageClassName,
  onPreview,
}) => {
  const [failed, setFailed] = useState(false)

  if (!image?.trim() || failed) {
    return null
  }

  return (
    <button
      type="button"
      onClick={(event) => {
        event.preventDefault()
        event.stopPropagation()
        onPreview(image, alt)
      }}
      className="shrink-0 rounded-lg transition hover:scale-[1.03] focus:outline-none focus:ring-2 focus:ring-orange-500"
      data-interaction-description-key="interactionDescriptions:publicMenu.components.publicMenuImageThumbnail.button.event"
    >
      <img
        src={image.toClientRequest()}
        alt={alt}
        loading="lazy"
        onError={() => setFailed(true)}
        className={imageClassName}
      />
    </button>
  )
}
